import config from 'react-global-configuration';
import {configService} from './../configService';
import axios from 'axios';
import md5 from 'md5';

export const fantacyService = {
    fantacyLogin,
}

function fantacyLogin(email,password) {
    var encpassword=md5(password);
    return axios  
        .get(`http://fantasy.tecpiniondev.com/login_atom?email=${email}&password=${encpassword}`)
        .then(res => {
            console.log(res);       
            return res;
        })
        .catch(err => configService.handleApiError(err));

}